var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"output html-output"},[_c('div',{staticClass:"content"},[(_vm.source)?_c('div',{staticClass:"source"},[_c('pre',[_vm._v(_vm._s(_vm.html))])]):_c('div',{staticClass:"rendered",domProps:{"innerHTML":_vm._s(_vm.html)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }